(function(angular){
	'use strict';
	
	angular
		.module('iraModule', [
			'apiModule',
			'coreModule',
			'formValidationModule',
			'googleRecaptchaModule',
			'ui.mask',
			'vcRecaptcha'
		])
		.constant('iraTypes', [
			{
				label: 'Traditional',
				value: 'TRADITIONAL_IRA'
			}, {
				label: 'Roth',
				value: 'ROTH'
			}, {
				label: 'SEP',
				value: 'SEP'
			},  {
				label: 'Simple',
				value: 'SIMPLE'
			}
		])
		.value('globalConfig', globalConfig);

})(window.angular);